import { Collapse } from "antd";
import styled from "styled-components";

export const Container = styled.div`
  padding: 64px 32px 128px;

  h1 {
    max-width: 600px;
    margin: 0 auto 1.5rem;
    font-weight: 400;
    font-size: 2rem;
    position: relative;
    line-height: 2.5rem;
    padding-bottom: 1rem;
    color: var(--velotax-font-color-light);

    :after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      height: 2px;
      width: 100px;
      background-color: var(--ant-primary-color);
    }
  }

  h2 {
    max-width: 600px;
    margin: 0 auto 1.5rem;
    font-weight: 400;
    font-size: 0.85rem;
    color: var(--velotax-font-color);

    button {
      padding: 0;
      height: 32px;
      min-width: 48px !important;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      span {
        margin: 0 !important;
        svg {
          fill: var(--velotax-font-color-light) !important;
          path {
            stroke: var(--velotax-font-color-light) !important;
          }
        }
      }
    }
  }

  span {
    &.success {
      color: var(--ant-success-color);
    }
    &.error {
      color: var(--ant-error-color);
    }
  }

  @media only screen and (max-device-width: 812px) {
    padding: 0 0 80px 0;

    h1 {
      max-width: calc(100% - 48px);
      margin: 0 24px 1.5rem;
      padding: 24px 0 1rem;
    }

    h2 {
      max-width: 100%;
      padding: 0 24px;
    }
  }
`;

export const Content = styled.div`
  padding: 32px;
  margin: 0 auto;
  max-width: 600px;
  border-radius: 4px;
  background-color: var(--velotax-background-color);
  margin-bottom: 32px;

  h1 {
    max-width: 100%;
    font-size: 2.25rem;
    padding-bottom: 0;
    margin: 0 0 1.5rem !important;

    :after {
      display: none;
    }
  }

  h2 {
    font-weight: 400;
    font-size: 1rem;
    color: var(--velotax-font-color-light);
  }

  & > .ant-collapse {
    border: none;
    & > .ant-collapse-item.ativos-categoria {
      border-radius: 4px;
      margin-bottom: 4px;
      border: 1px solid var(--velotax-background-color);
      background-color: var(--velotax-background-color-ghost);
      &:last-of-type {
        margin-bottom: 0;
      }
      h2 {
        margin: 0;
        font-weight: 500;
        font-size: 1.125rem;
      }
      & > .ant-collapse-content {
        background-color: var(--velotax-background-color);
        border-top: 1px solid var(--velotax-background-color);
        & > .ant-collapse-content-box {
          padding: 0;
        }
      }
    }
  }

  div.ant-typography {
    margin: 0 0 0.25rem;
    font-size: 1rem;
    span {
      font-weight: 500;
      font-size: 1.25rem;
      &.success {
        margin-left: 8px;
        color: var(--ant-success-color);
      }
      &.error {
        margin-left: 8px;
        color: var(--ant-error-color);
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    margin-bottom: 0;
    border-radius: 0;
    padding: 32px 24px;

    h1,
    h2 {
      padding: 0;
    }

    div.ant-typography {
      font-size: 0.8rem;
      span {
        font-size: 0.95rem;
      }
    }

    &:last-of-type {
      margin-bottom: 32px;
    }
  }
`;

export const Posicoes = styled(Collapse)`
  border: none;

  &.blur-content {
    opacity: 0.5;
    filter: blur(4px);
  }

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-weight: 500;
      font-size: 1.25rem;
      color: var(--velotax-font-color-light);

      span {
        margin-left: 8px;
        font-size: 0.875rem;
      }
    }

    .posicao {
      font-weight: 500;
      font-size: 1.5rem;
      color: var(--velotax-font-color-light);
    }
  }

  @media only screen and (max-device-width: 812px) {
    .header {
      .title {
        font-size: 1rem;
        span {
          margin-left: 8px;
          font-size: 0.675rem;
        }
      }
      .posicao {
        font-size: 1rem;
      }
    }
  }
`;

export const BlurContent = styled.div`
  margin-top: 8px;
  position: relative;
  user-select: none;
  .blur-content-title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 100px;
    font-weight: 500;
    font-size: 1.25rem;
    text-align: center;
    row-gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    color: var(--velotax-font-color-light);
  }

  @media only screen and (max-device-width: 812px) {
    .blur-content-title {
      padding: 0 16px;
      font-size: 1rem;
    }
  }
`;

export const JuridicMessage = styled.p`
  margin: 1rem auto 0 auto;
  max-width: 600px;
  padding: 0 1rem;
  font-size: 0.85rem;
  font-weight: 400;
  text-align: justify;
  line-height: 1.5rem;
  color: #ABAAA8;
`

export const Toolbar = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  margin: 0 auto 1.5rem auto;
  justify-content: space-between;
`